import React from 'react'
import './index.css'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { applyMiddleware, createStore } from 'redux'
import { loadingBarMiddleware } from 'react-redux-loading-bar'
import { composeWithDevTools } from 'redux-devtools-extension'
import { Router } from 'react-router-dom'
import { rootReducer } from './Redux/_reducers/rootReducer'
import { history } from './_history'
import './i18n'
import App from './App'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { APP_VERSION, USE_DEV_API } from './config'
import { dsn } from '../sentryDSN'
import ReactDOM from 'react-dom'
import { configureStore } from '@reduxjs/toolkit'
// import { configureStore } from '@reduxjs/toolkit'

function initFacebookSdk() {
	// wait for facebook sdk to initialize before starting the react app
	window.fbAsyncInit = function () {
		window.FB.init({
			appId: '437100457854625',
			cookie: true,
			xfbml: true,
			version: 'v16.0',
		})
	}

	// FB.AppEvents.logPageView()

	// load facebook sdk script
	;(function (d, s, id) {
		var js,
			fjs = d.getElementsByTagName(s)[0]
		if (d.getElementById(id)) {
			return
		}
		js = d.createElement(s)
		js.id = id
		js.src = 'https://connect.facebook.net/en_US/sdk.js'
		fjs.parentNode.insertBefore(js, fjs)
	})(document, 'script', 'facebook-jssdk')
}

if (!USE_DEV_API) {
	Sentry.init({
		dsn,
		integrations: [new BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
		// release: APP_VERSION,
		environment: process.env.NODE_ENV,
		ignoreErrors: ['ResizeObserver loop limit exceeded'],
	})
}

// Yandex Metrika
if (!USE_DEV_API) {
	;(function (m, e, t, r, i, k, a) {
		m[i] =
			m[i] ||
			function () {
				;(m[i].a = m[i].a || []).push(arguments)
			}
		m[i].l = 1 * new Date()
		for (var j = 0; j < document.scripts.length; j++) {
			if (document.scripts[j].src === r) {
				return
			}
		}
		;(k = e.createElement(t)),
			(a = e.getElementsByTagName(t)[0]),
			(k.async = 1),
			(k.src = r),
			a.parentNode.insertBefore(k, a)
	})(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

	ym(90291802, 'init', {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
		webvisor: true,
	})
}

initFacebookSdk()

export const store = createStore(
	rootReducer,
	process.env.NODE_ENV === 'production'
		? applyMiddleware(thunkMiddleware, loadingBarMiddleware())
		: composeWithDevTools(applyMiddleware(thunkMiddleware, loadingBarMiddleware()))
)

// export const store = configureStore({
// 	reducer: rootReducer,
// 	devTools:
// 		process.env.NODE_ENV === 'production'
// 			? applyMiddleware(thunkMiddleware, loadingBarMiddleware())
// 			: composeWithDevTools(applyMiddleware(thunkMiddleware, loadingBarMiddleware())),
// })

ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<App />
		</Router>
	</Provider>,
	document.getElementById('root')
)

// createRoot(document.getElementById('root')).render(
// 	<Provider store={store}>
// 		<Router history={history}>
// 			<App />
// 		</Router>
// 	</Provider>
// )

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.getRegistrations().then(function (registrations) {
		for (let registration of registrations) {
			registration.unregister()
		}
	})
} else {
	console.log('Your browser does not support the Service-Worker!')
}
